interface StageRUMConfig {
  identityPoolId: string;
  endpoint: string;
  applicationId: string;
}

interface StageFeatures {
  pncFeatureEnabled: boolean;
}

interface StageConfiguration {
  rum: StageRUMConfig;
}

export const STAGE_CONFIGS: Record<string, StageConfiguration> = {
  alpha: {
    rum: {
      identityPoolId: "us-east-1:c0f37b7f-234f-4b54-8baa-a514e92b2df2",
      endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
      applicationId: "733e4cae-6b65-40ac-bbc7-c68d6a0e2c53",
    },
  },
  beta: {
    rum: {
      identityPoolId: "us-east-1:b9365c57-235a-40a4-a1f1-44f129f16c8a",
      endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
      applicationId: "293ff9c9-bbdf-43c1-b530-0ed9a8009cca",
    },
  },
  gamma: {
    rum: {
      identityPoolId: "us-east-1:a6e490d0-7679-41cd-8b89-6ace0600bb9c",
      endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
      applicationId: "c68cb1c8-07b6-4a14-8cae-f768be17d852",
    },
  },
  prod: {
    rum: {
      identityPoolId: "us-east-1:fd2b5195-5bdd-4622-af11-25b001336797",
      endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
      applicationId: "708a6ed4-b2a6-48e7-a6a9-95067dadaecc",
    },
  },
};

export function getStageFromHostname(
  hostname: string = window.location.hostname,
): string | null {
  if (hostname.includes("alpha.gaia")) return "alpha";
  if (hostname.includes("beta.gaia")) return "beta";
  if (hostname.includes("gamma.gaia")) return "gamma";
  if (hostname.includes("prod.gaia")) return "prod";
  return null;
}

export function getStageFeatures(): StageFeatures {
  return {
    pncFeatureEnabled: true,
  };
}

export type { StageRUMConfig, StageFeatures, StageConfiguration };
